import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiHome,
  FiUsers,
  FiBookOpen,
  FiGrid,
  FiFileText,
  FiBarChart2,
  FiUser,
  FiSettings,
  FiLogOut,
  FiMoreHorizontal,
  FiUserX, // ✅ Tambah icon UserX
} from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";

const sidebarItems = [
  { to: "/admin", label: "Beranda", icon: FiHome },
  { to: "/admin/guru", label: "Data Guru", icon: FiUser },
  { to: "/admin/siswa", label: "Data Siswa", icon: FiUsers },
  { to: "/admin/mapel", label: "Data Mapel", icon: FiBookOpen },
  { to: "/admin/kelas", label: "Data Kelas", icon: FiGrid },
  { to: "/admin/jadwal", label: "Data Jadwal", icon: FiFileText },
  { to: "/admin/laporan", label: "Laporan", icon: FiBarChart2 },
  { to: "/admin/pengguna", label: "Data Pengguna", icon: FiUser },
  { to: "/admin/pengaturan", label: "Pengaturan", icon: FiSettings },
];

export default function AdminLayout({ children }) {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-slate-100">
      {/* ================= SIDEBAR ================= */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-40
          w-64 bg-white shadow-lg
          transform transition-transform duration-300
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        <div className="px-6 py-5 flex items-center gap-3">
          <img src="/logo.png" alt="Logo" className="w-9 h-9 object-contain" />
          <h1 className="font-bold text-xl text-blue-700">SIPENSA</h1>
        </div>

        <nav className="px-4 flex flex-col h-[calc(100vh-80px)]">
          <div className="space-y-1">
            {sidebarItems.map((item) => (
              <SidebarItem
                key={item.to}
                to={item.to}
                icon={item.icon}
                label={item.label}
                active={location.pathname === item.to}
                onClick={() => setOpen(false)}
              />
            ))}
          </div>

          <div className="mt-auto px-4 py-4 border-t border-slate-200">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition"
            >
              <FiLogOut className="text-lg" />
              Keluar
            </button>
          </div>
        </nav>
      </aside>

      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* ================= CONTENT ================= */}
      <div className="flex flex-col min-h-screen md:ml-64">
        <header className="bg-white shadow-sm px-6 py-4 flex items-center justify-between sticky top-0 z-40">
          <div className="flex items-center gap-4">
            <button className="md:hidden text-xl" onClick={() => setOpen(!open)}>
              ☰
            </button>
            <p className="font-semibold text-lg">
              Selamat Datang, <span className="text-blue-600">Admin</span> 👋
            </p>
          </div>

          {/* DROPDOWN */}
          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-slate-600 hover:text-slate-800"
            >
              <FiMoreHorizontal className="text-xl" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-52 bg-white rounded-lg shadow-lg border text-sm z-50">
                <Link
                  to="/admin/petunjuk"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiBookOpen className="text-slate-500" />
                  Petunjuk
                </Link>
                {/* MENU TAMBAHAN BARU */}
                <Link
                  to="/admin/guru-absen"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiUserX className="text-slate-500" />
                  Guru Tidak Hadir
                </Link>
                <Link
                  to="/admin/pengaturan"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiSettings className="text-slate-500" />
                  Pengaturan
                </Link>
                <div className="border-t border-slate-100 my-1"></div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 text-left"
                >
                  <FiLogOut />
                  Keluar
                </button>
              </div>
            )}
          </div>
        </header>

        <main className="p-4 md:p-6 bg-slate-100 flex-1">
          {children}
        </main>
      </div>
    </div>
  );
}

function SidebarItem({ to, icon: Icon, label, active, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition
        ${
          active
            ? "bg-blue-100 text-blue-700"
            : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"
        }`}
    >
      {Icon && <Icon className="text-lg" />}
      {label}
    </Link>
  );
}